import React, { useState } from "react";
import logo from "../../assets/images/logo-rewind.png";
import { useTranslation } from "react-i18next";
import TextInput from "../ui/TextInput";
import Button from "../ui/Button";
import { CreateProjectModalProps } from "../../types/screensTypes";
import studio from "../../components/modals/StudioModal.module.css";
import { ModalPortal } from "./ModalPortal";

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({ isOpen, onClose, onAddToProject }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [newProjectName, setNewProjectName] = useState<string>("");

    const handleAddToProject = () => {
        if (newProjectName.trim()) {
            onAddToProject(newProjectName);
            setNewProjectName(""); // Clear input field
            onClose();
        } else {
            alert(t("warningSelectProject"));
        }
    };

    if (!isOpen) return null;

    return (
        <ModalPortal>
            <div className={studio.overlayTop}>
                <div className={studio.projectModalContent}>
                    <div className={studio.logoWrap}>
                        <img src={logo} alt="Logo" />
                    </div>
                    <h1 className={studio.projectModalTitle}>{t("createNewProject")}</h1>

                    <div className={studio.projectSectionNew}>
                        <div className={studio.projectRow}>
                            <TextInput
                                placeholder={t("nameOfTheNewProject")}
                                value={newProjectName}
                                size="small"
                                fullWidth
                                onChange={(e) => setNewProjectName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={studio.buttonsCentered}>
                        <Button
                            variant="primary"
                            shape="pill"
                            block
                            label={t("createProject")}
                            onClick={handleAddToProject}
                        />
                        <Button variant="cancel" shape="pill" block label={t("close")} onClick={onClose} />
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default CreateProjectModal;
